import type { ReviewWorkflowState } from './systemMapReview';

/**
 * Barra "Revisar pendientes" — navegación secuencial sobre la cola de
 * paradas `needs_review` (Anterior/Siguiente/contador), más los dos
 * atajos de esta fase: "Confirmar actual" (simula en sesión, nunca
 * persiste) y "Editar asociación" (abre el modo edición sobre la parada
 * actual). Ambos atajos llaman exactamente a las mismas acciones que están
 * disponibles desde el panel de detalle para cualquier parada — no hay
 * lógica duplicada, solo una forma más rápida de llegar a ellas durante la
 * revisión secuencial.
 */
export function SystemMapReviewBar({
  review,
  stopName,
  confirmed,
  editing,
  onConfirm,
  onEditAssociation,
}: {
  review: ReviewWorkflowState;
  stopName: string | null;
  confirmed: boolean;
  editing: boolean;
  onConfirm: () => void;
  onEditAssociation: () => void;
}): JSX.Element | null {
  if (!review.active) return null;

  return (
    <div className="smap-review-bar">
      <div className="smap-review-bar-info">
        <span className="smap-review-bar-title">Revisar pendientes</span>
        <span className="smap-review-bar-counter">
          {review.total > 0 ? `${review.index + 1} / ${review.total}` : 'Sin pendientes'}
        </span>
        {stopName && <span className="smap-review-bar-stopname">{stopName}</span>}
      </div>
      <div className="smap-review-bar-actions">
        <button type="button" onClick={review.prev} disabled={review.index === 0}>
          ← Anterior
        </button>
        <button type="button" onClick={review.next} disabled={review.index >= review.total - 1}>
          Siguiente →
        </button>
        <button
          type="button"
          className={confirmed ? 'smap-review-bar-confirmed' : ''}
          onClick={onConfirm}
          disabled={review.total === 0}
        >
          {confirmed ? '✓ Confirmada en sesión' : 'Confirmar actual'}
        </button>
        <button type="button" onClick={onEditAssociation} disabled={review.total === 0}>
          {editing ? 'Cerrar edición' : 'Editar asociación'}
        </button>
        <button type="button" className="smap-review-bar-exit" onClick={review.exit}>
          Salir de revisión
        </button>
      </div>
    </div>
  );
}
